export enum PriceSummaryDataHooks {
  Item = 'price-summary-item',
  Label = 'price-summary-label',
  Description = 'price-summary-description',
}
